import { programAPI } from 'api/program';
import { FindAllProgramDto } from 'dto/program';
import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { QUERY_KEY } from 'utils/enums';

type PropsType = {
  filters: FindAllProgramDto;
};

export function useFindAllProgram(props: PropsType) {
  const query = useQuery({
    queryKey: QUERY_KEY.FIND_ALL_PROGRAM,
    queryFn: () => programAPI.findAll(props.filters),
  });

  useEffect(() => {
    query.refetch();
  }, [props.filters]);

  return {
    query: query,
    count: query.data?.count ?? 0,
    rows: query.data?.rows ?? [],
    loading: query.isLoading || query.isFetching || query.isRefetching,
  };
}
